// scroll bar
import 'simplebar/src/simplebar.css';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

//
import App from './App';
import { AuthProvider } from './components/customContextProviders/AuthContext';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://8b0684832f2c44fe9104f3e6da0c83cc@o1292133.ingest.sentry.io/6513582',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0
});

// ----------------------------------------------------------------------

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// const channel = new BroadcastChannel('tab');
// channel.postMessage('another-tab');
// channel.addEventListener('message', (msg) => {
//   if (msg.data === 'another-tab') {
//     channel.postMessage('instance_available');
//   }
//   else if(msg.data === 'instance_available'){
//     window.open("", "_self", "").close();
//     alert("instance_available")
//   }
// });
